import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, FeaturedIcon } from '@myhealth-raccoon/components';

import { ContentContainer } from 'src/components/ContentContainer';
import { StickyBottomBar } from 'src/components/StickyBottomBar';

export function PatientNotFound() {
    const navigate = useNavigate();

    return (
        <>
            <ContentContainer className="flex-1 space-y-6 text-center lg:flex-none">
                <FeaturedIcon size="lg" color="error" className="mx-auto mb-8" />
                <h1 className="text-2xl font-medium text-gray-900">We couldn't find a matching patient record.</h1>
                <p>
                    We couldn’t find a match for the details you provided in our active patient records. Please ensure
                    that your <b>name, date of birth, and mobile number</b> match exactly as they were entered during
                    registration and try again.
                </p>
                <p>
                    If you don’t have an existing record, please exit and select 'New patient'. Alternatively, contact
                    the clinic directly for assistance.
                </p>
            </ContentContainer>
            <StickyBottomBar>
                <Button className="w-full" color="gray" onClick={() => navigate(-1)}>
                    Back
                </Button>
            </StickyBottomBar>
        </>
    );
}
